const logonRoutes = [
    {
        path: "/login/register",
        name: "注册-选择主体类型",
        component: () => import("@/views/login/children/register-account-type-select/register-account-type-select.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-info-white",
        name: "注册-资料填写",
        component: () => import("@/views/login/children/register-account-info-white/register-account-info-white.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-info-white/main",
        name: "注册-主体信息",
        component: () => import("@/views/login/children/register-account-info-white/children/register-account-info-main/register-account-info-main.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-info-white/operate",
        name: "注册-经营信息",
        component: () => import("@/views/login/children/register-account-info-white/children/register-account-info-operate/register-account-info-operate.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-info-white/industry",
        name: "注册-行业资质",
        component: () => import("@/views/login/children/register-account-info-white/children/register-account-info-industry/register-account-info-industry.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-info-white/settlement",
        name: "注册-结算账户",
        component: () => import("@/views/login/children/register-account-info-white/children/register-account-info-settlement/register-account-info-settlement.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-info-white/admin",
        name: "注册-超级管理员",
        component: () => import("@/views/login/children/register-account-info-white/children/register-account-info-admin/register-account-info-admin.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-info-white/supplement",
        name: "注册-补充材料",
        component: () => import("@/views/login/children/register-account-info-white/children/register-account-info-supplement/register-account-info-supplement.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-info-white/loading",
        name: "注册-提交中",
        component: () => import("@/views/login/children/register-account-info-white/children/register-account-info-loading/register-account-info-loading.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-schedule",
        name: "注册-申请单进度",
        component: () => import("@/views/login/children/register-account-schedule/register-account-schedule.vue"),
        meta: {},
    },
    {
        path: "/login/register/account-schedule/wechat-guide",
        name: "注册-示例与操作指引",
        component: () => import("@/views/login/children/register-account-schedule/children/schedule-wechat-guide/schedule-wechat-guide.vue"),
        meta: {},
    },
    {
        path: "/login/register/register-account-wx-info",
        name: "注册-填写微信公众号/小程序信息",
        component: () => import("@/views/login/children/register-account-wx-info/register-account-wx-info.vue"),
        meta: {},
    },
    {
        path: "/login/register/register-account-wx-info/loading",
        name: "注册-填写微信公众号/小程序信息审核中",
        component: () => import("@/views/login/children/register-account-wx-info/children/register-account-wx-info-loading/register-account-wx-info-loading.vue"),
        meta: {},
    },
];
export default logonRoutes;
